export enum IvfTreatmentCycle {
    first = '1',
    second= '2',
    third = '3',
    other = 'O',
}
(IvfTreatmentCycle as any)['first'] = '1';
(IvfTreatmentCycle as any)['second'] = '2';
(IvfTreatmentCycle as any)['third'] = '3';
(IvfTreatmentCycle as any)['other'] = 'O';